import React, { useEffect, useContext } from 'react';
import { useState } from 'react';
import { BsBasketFill } from "react-icons/bs";
import Offcanvas from 'react-bootstrap/Offcanvas';
import ProductCar from './ProductCar';
import products from '../controller/api/Product'
import { GetUserContext } from '../Context/GetUserContext';
import formats from '../controller/views/formats';
import user from '../controller/api/User'
import Company from '../controller/api/Company';
import { useNavigate } from 'react-router-dom';
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import FinalizeCart from './PageOrders/FinalizeCart';
import Pedido from '../controller/api/Pedido';
import { MdRemoveShoppingCart } from "react-icons/md";
import './CarMarket.css'
import purchasingRule from '../controller/views/purchasingRule';

const CarMarket = () => {
    const { size, habilityEntrega, setHabilityEntrega, fetchTimestampApp, setFetchTimestampApp, show, setShow, prodsCar, setProdsCar, setMyContext, axiosConfig, qtdTotal, setqtdTotal } = useContext(GetUserContext);
    const newCompany = new Company();
    const navigate = useNavigate();
    const [userDatas, setUserDatas] = useState([]);
    const [load, setLoad] = useState(false);
    const [idUser, setIdUser] = useState();
    const [habilityValueTotal, setHabilityValueTotal] = useState(false);
    const [parcelAndPrice, setParcelAndPrice] = useState({});
    const minimumPurchaseAmountPB = 170.00;
    const minimumPurchaseRNRetirada = 100.00;
    const minimumPurchaseRNEntrega = 150.00;
    const [minimumPurchase, setMinimumPurchase] = useState(0)
    const [menssage, setMenssage] = useState('')

    const dataUserFilter = JSON.parse(localStorage.getItem('user')) || [];
    let qtdTotalLocal = localStorage.getItem("qtdTotal");


    useEffect(() => {
        const storedItems = JSON.parse(localStorage.getItem(`itemCardProd${idUser}`)) || [];
        setLoad(true);

        newCompany.getCompany(axiosConfig)
            .then(userDatas => {
                setIdUser(userDatas?.data?.Company_ID);
                const verif = storedItems.filter(item => item?.Company_ID === userDatas?.data?.Company_ID);
                if (verif.length !== 0) {
                    setUserDatas(userDatas.data);
                    setProdsCar(storedItems);
                } else {
                    setProdsCar([]);
                }
                setLoad(false);
            })
            .catch(err => {
                setLoad(false);
                return err
            });
    }, [fetchTimestampApp, idUser]);

    useEffect(() => {
        const total = prodsCar.reduce((acc, ps) => acc + parseFloat(ps.ValorQtd), 0);
        localStorage.setItem('qtdTotal', total.toFixed(2))
        setqtdTotal(total.toFixed(2))
    }, [prodsCar, fetchTimestampApp])

    const handleClose = () => {
        setShow(false)
    };
    const handleShow = () => {
        setFetchTimestampApp(Date.now());
        setShow(true)
    };
    const handleToOrder = () => { navigate('/pedidos') };

    useEffect(() => {
        const isPB = dataUserFilter?.CompleteAddress?.state?.Uf === 'PB';

        if (isPB) {
            setMinimumPurchase(minimumPurchaseAmountPB);
            setMenssage('Pedido minimo');

            if (qtdTotalLocal >= minimumPurchaseAmountPB) {
                setHabilityEntrega(true)
                setHabilityValueTotal(true);
            } else {
                setHabilityValueTotal(false);
            }

        } else {
            setMinimumPurchase(minimumPurchaseRNRetirada);

            if (qtdTotalLocal < minimumPurchaseRNRetirada) {
                setMenssage('Pedido minimo');
                setHabilityValueTotal(false);

            } else if (qtdTotalLocal < minimumPurchaseRNEntrega) {
                setMenssage('');
                setHabilityEntrega(false)
                setHabilityValueTotal(true);
            } else {
                setMenssage('');
                setHabilityEntrega(true)
                setHabilityValueTotal(true);
            }
        }
    }, [qtdTotalLocal]);

    const PurchasingRule = new purchasingRule(parseFloat(qtdTotalLocal))
    useEffect(() => {
        PurchasingRule.cardPayment(dataUserFilter?.CompleteAddress?.state?.Uf)
            .then(response => {
                setParcelAndPrice(response)
            })
            .catch(err => {
                console.log(err);
            });
    }, [qtdTotalLocal])

    return (
        <>
            <div className='car-market bg-warning' onClick={handleShow}>
                <BsBasketFill style={{ fontSize: "1.3em", marginRight: "5px" }} />
                <span>Carrinho: <strong>{prodsCar.length}</strong></span>
            </div>

            <Offcanvas className="custom-offcanvas" show={show} onHide={handleClose} placement="end" >
                {load ? (<div className='load-prod-car-prods'> <AiOutlineLoading3Quarters className='icon-load' /></div>) : (<></>)}

                <Offcanvas.Header className='border' closeButton>
                    {
                        size?.categoria !== 'xlarge' && size?.categoria !== 'large' ?
                            (
                                <div>
                                    <h5>Total: <strong className='text-dark'>R$ {formats.formatPrice(qtdTotalLocal)}</strong></h5>
                                    <div className='desc-parcelas'>{formats.formatParcel(parcelAndPrice, dataUserFilter?.CompleteAddress?.state?.Uf)?.parcelas}</div>
                                    {
                                        habilityValueTotal ?
                                            (<FinalizeCart userDatas={userDatas} onClick={handleToOrder} />)
                                            :
                                            (<button className='btn btn-secondary opacity-75'>
                                                {menssage}
                                                <br></br>
                                                R$ {formats.formatPrice(minimumPurchase)}
                                            </button >)
                                    }
                                </div>
                            )
                            :
                            (
                                <div className='d-flex align-items-center justify-content-around w-100'>
                                    <div>
                                        <div>
                                            <h3>Total: <strong className='text-dark'>R$ {formats.formatPrice(qtdTotalLocal)}</strong></h3>
                                            <div className='desc-parcelas'>{formats.formatParcel(parcelAndPrice, dataUserFilter?.CompleteAddress?.state?.Uf)?.parcelas}</div>
                                        </div>
                                    </div >
                                    {habilityValueTotal ? (<FinalizeCart userDatas={userDatas} onClick={handleToOrder} />) : (<button className='btn btn-secondary opacity-75'>{menssage} < br ></br > R$ {formats.formatPrice(minimumPurchase)}</button >)
                                    }
                                </div >
                            )
                    }
                    <hr></hr   >
                </Offcanvas.Header >
                <Offcanvas.Body className='area-products-car-market '>
                    {
                        prodsCar.length == 0 ?
                            (<div className='car-hollow'><MdRemoveShoppingCart /></div>) :
                            (prodsCar?.map((product, index) => (
                                <React.Fragment key={index}>
                                    <ProductCar idUser={idUser} product={product?.product} allItens={product} />
                                </React.Fragment>
                            )))
                    }
                </Offcanvas.Body>
            </Offcanvas >
        </>
    )
}

export default CarMarket